export default __webpack_public_path__ + "static/media/oauth2.9fb6882b.png";